import { makeApiRequest } from './api';

export type TTenantTheme = {
  theme: {
    primaryColor: string | null;
    secondaryColor: string | null;
    logoUrl: string | null;
    faviconUrl: string | null;
    themeConfig: Record<string, any> | null;
    metadata?: {
      title?: string | null;
      description?: string | null;
    } | null;
    name: string | null;
    title?: string | null;
    description?: string | null;
    paymentMethod?: 'prepaid' | 'postpaid' | null;
    currency?: string | null;
  };
};

export const getTenantTheme = async () =>
  await makeApiRequest<{
    success: boolean;
    data?: TTenantTheme;
    theme?: TTenantTheme['theme'];
  }>('/tenants/current/theme');

export const getCurrentTenant = async (token: string) =>
  await makeApiRequest<{
    message: string;
    data?: {
      paymentMethod?: 'prepaid' | 'postpaid' | null;
    };
  }>('/tenants/current', {
    token,
  });
